export class ChangePassword
{
    email:string
  passwordAgain:string
  newPassword:string
  otp:string

}